import { render, staticRenderFns } from "./monkeyKing.vue?vue&type=template&id=5f1755ea&scoped=true"
import script from "./monkeyKing.vue?vue&type=script&lang=js"
export * from "./monkeyKing.vue?vue&type=script&lang=js"
import style0 from "./monkeyKing.vue?vue&type=style&index=0&id=5f1755ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1755ea",
  null
  
)

export default component.exports